<template>
  <el-select
    style="width: 100%"
    :size="size"
    :value="idProxyServer"
    :loading="loading"
    filterable
    v-on="$listeners"
  >
    <el-option
      v-for="server in recommendedProxyServers"
      :key="server.id"
      :label="server.name"
      :value="server.id"
    >
      <span class="left_info">{{ server.name }}</span>
      <span class="right_info">
        <fa :icon="iconExchange" :class="server.classStreams" />
        {{ server.freely_cameras_count }}
      </span>
    </el-option>
  </el-select>
</template>

<script>
import { FontAwesomeIcon as fa } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faVideo } from "@fortawesome/free-solid-svg-icons";
import { ApiService } from "@/api";

library.add(faVideo);

export default {
  name: "ProxyServersSelect",
  components: {
    fa,
  },
  model: {
    prop: "idProxyServer",
    event: "change",
  },
  props: {
    idProxyServer: {
      type: Number,
      default: null,
    },
    idMediaCore: {
      type: Number,
      default: null,
    },
    idDvrServer: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: "small",
    },
  },
  data() {
    return {
      loading: false,
      recommendedProxyServers: [],
      requestId: 0,
    };
  },
  computed: {
    iconExchange() {
      return faVideo;
    },
  },
  watch: {
    idMediaCore: {
      immediate: true,
      handler() {
        this.pullRecommendedProxyServers();
      },
    },
    idDvrServer() {
      this.pullRecommendedProxyServers();
    },
  },
  methods: {
    pullRecommendedProxyServers() {
      if (!Number.isInteger(this.idMediaCore)) {
        this.recommendedProxyServers = [];
        return Promise.resolve();
      }

      const requestId = ++this.requestId;
      this.loading = true;

      return ApiService.servers
        .getProxyRecommendByMediaCore(this.idMediaCore, this.idDvrServer || "")
        .then((servers) => {
          if (requestId !== this.requestId) return;

          this.recommendedProxyServers = servers.map((server) => ({
            ...server,
            classStreams: server.freely_cameras_count <= 0 ? "color_alert" : "color_recommend",
          }));
        })
        .catch(() => {
          if (requestId !== this.requestId) return;
          this.recommendedProxyServers = [];
          this.$message.error("Не удалось загрузить список серверов");
        })
        .finally(() => {
          if (requestId === this.requestId) this.loading = false;
        });
    },
  },
};
</script>

<style>
.left_info {
  float: left;
  padding-right: 5px;
}
.right_info {
  float: right;
  text-align: left;
  min-width: 130px;
}
</style>
